import { inject } from 'mobx-react';
import { LoadingComponent, StageLoadingComponent } from './component';
export const Loading = inject(({ ui }) => ({
    loading: ui.loading,
}))(LoadingComponent);
export const StageLoading = inject(({ ui }) => ({
    stageLoading: ui.stageLoading,
}))(StageLoadingComponent);
//# sourceMappingURL=index.js.map